module.exports = __webpack_public_path__ + "img/menu-thai-express-complete.5c2ec3d0.jpg";